/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { JsonEditor as Editor } from "jsoneditor-react";
import Typography from "@material-ui/core/Typography";
import "jsoneditor-react/es/editor.min.css";

const JsonEditor = ({
  defaultMissionSelection,
  event,
  saveEvent,
  ajv,
  schema,
  mode = "tree",
}) => {
  const jsonEditorRef = useRef(null);
  useEffect(() => {
    if (jsonEditorRef.current !== null) {
      jsonEditorRef.current.set(event);
    }
  }, [defaultMissionSelection]);

  const setRef = (instance) => {
    if (instance) {
      jsonEditorRef.current = instance.jsonEditor;
    } else {
      jsonEditorRef.current = null;
    }
  };

  return (
    <StyledJsonEditorWrapper>
      <Editor
        value={event}
        schema={schema({})}
        ajv={ajv}
        onChange={saveEvent}
        ref={setRef}
        mode={mode}
      />
    </StyledJsonEditorWrapper>
  );
};

const StyledJsonEditorWrapper = styled.div`
  width: 100%;
  background: #36393f;
  border-radius: 5px;
  padding: 10px;
  > div {
    background: #ffeded;
    height: 88%;
  }
`;

export default JsonEditor;
